import {
	Button,
	FormControl,
	Grid,
	InputLabel,
	MenuItem,
	Select,
	TextField,
} from "@mui/material";
import { Box } from "@mui/system";
import {
	createFormData,
	extractUpdatedFields,
	isEmptyObject,
} from "nhb-toolbox";
import { Dispatch, SetStateAction, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useForm } from "react-hook-form";
import { useAuthContext } from "src/components/Context/AuthContext/AuthContext";
import { url } from "src/Helpers/utils/constants";
import { useApiMutation } from "src/hooks/useApiMutation";
import { toast } from "src/Toaster/Toaster";
import { IGuest } from "src/Types/module/guestAndSpeaker/type/guestAndSpeaker";
import { muiStyles } from "src/Utils/Styles";

const useStyles = muiStyles;

interface IProps {
	guest: IGuest;
	setShowModal: Dispatch<SetStateAction<boolean>>;
}
const UpdateGuestAndSpeaker = ({ guest, setShowModal }: IProps) => {
	const { register, handleSubmit } = useForm();
	const [guestType, setGuestType] = useState<string>("");
	const [status, setStatus] = useState<string>("");
	const [photo, setPhoto] = useState<string>("");

	const { mutate: updateGuest, isPending } = useApiMutation<FormData, void>({
		method: "PUT",
		endPoint: `${url}/api/fair/for-admin/guest-or-speaker/update`,
		invalidateQueries: ["Guests", "Guest"],
	});

	const { user } = useAuthContext();

	const onSubmit = (inputs: any) => {
		const updatedData = extractUpdatedFields(guest, {
			...inputs,
			guest_speaker_type: guestType,
			guest_speaker_status: status,
		});

		if (isEmptyObject(updatedData)) {
			return toast.fire({
				icon: "warning",
				title: "Nothing to update!",
				position: "top",
			});
		}

		const formData = createFormData({
			...updatedData,
			photo,
			guest_speaker_id: guest.guest_speaker_id,
			guest_speaker_updated_by: user.user_admin_id,
		});

		updateGuest(formData);

		setShowModal(false);
	};

	return (
		<>
			<Helmet>
				<title>BTTF - Update Guest & Speaker</title>
			</Helmet>

			<Box
				onSubmit={handleSubmit(onSubmit)}
				component="form"
				sx={{ p: 2, mt: 1 }}
			>
				<Grid container spacing={2}>
					<Grid xs={12} sm={6} item>
						<TextField
							margin="normal"
							fullWidth
							id="name"
							label="Guest name"
							defaultValue={guest.guest_speaker_name}
							{...register("guest_speaker_name")}
							type="text"
							autoFocus
							variant="outlined"
						/>
					</Grid>

					<Grid xs={12} sm={6} item>
						<TextField
							margin="normal"
							fullWidth
							id="name"
							label="Company name"
							defaultValue={guest.guest_speaker_company_name}
							{...register("guest_speaker_company_name")}
							type="text"
							autoFocus
							variant="outlined"
						/>
					</Grid>
					<Grid xs={12} sm={6} item>
						<TextField
							margin="normal"
							fullWidth
							id="text"
							label="Designation"
							defaultValue={guest.guest_speaker_designation}
							{...register("guest_speaker_designation")}
							type="text"
							autoFocus
							variant="outlined"
						/>
					</Grid>
					<Grid xs={12} sm={6} item>
						<FormControl fullWidth sx={{ mt: 2 }}>
							<InputLabel id="status">Status</InputLabel>
							<Select
								labelId="status"
								id="status-select"
								defaultValue={
									guest
										? guest.guest_speaker_status
										: "pending"
								}
								onChange={(e) => setStatus(e.target.value)}
							>
								<MenuItem value="approved">Approved</MenuItem>
								<MenuItem value="pending">Pending</MenuItem>
								<MenuItem value="rejected">Rejected</MenuItem>
							</Select>
						</FormControl>
					</Grid>
					<Grid xs={12} sm={6} lg={6} item>
						<FormControl fullWidth sx={{ mt: 2 }}>
							<InputLabel id="type">Type</InputLabel>
							<Select
								labelId="type"
								id="type-select"
								defaultValue={guest.guest_speaker_type}
								onChange={(e) => setGuestType(e.target.value)}
							>
								<MenuItem value="guest">Guest</MenuItem>
								<MenuItem value="speaker">Speaker</MenuItem>
							</Select>
						</FormControl>
					</Grid>
					<Grid item xs={12} sm={6} lg={6}>
						<TextField
							margin="normal"
							fullWidth
							id="file"
							label="Choose Guest Photo"
							InputLabelProps={{ shrink: true }}
							onChange={(e: any) => setPhoto(e.target.files[0])}
							autoComplete="file"
							type="file"
							autoFocus
						/>
					</Grid>
					<Grid item lg={12}>
						<TextField
							label="Guest details"
							placeholder="Enter some details about this Guest here.."
							multiline
							defaultValue={guest.guest_speaker_details}
							{...register("guest_speaker_details")}
							rows={5}
							maxRows={10}
							fullWidth
						/>
					</Grid>
				</Grid>

				{isPending ? (
					<Button
						disabled
						fullWidth
						variant="contained"
						disableElevation
						sx={{
							mt: 3,
							mb: 2,
							py: 1,
						}}
					>
						Updating...
					</Button>
				) : (
					<Button
						type="submit"
						fullWidth
						variant="contained"
						disableElevation
						sx={{
							mt: 3,
							mb: 2,
							py: 1,
						}}
					>
						Update Guest
					</Button>
				)}
			</Box>
		</>
	);
};

export default UpdateGuestAndSpeaker;
